/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Step2_BodyInputs */

const es_cap_step2_body = /** @type {(inputs: Cap_Step2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuando un armador necesita patrón en tu zona y fechas, te llega la propuesta al instante.`)
};

const gl_cap_step2_body = /** @type {(inputs: Cap_Step2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cando un armador precisa patrón na túa zona e datas, chega a proposta ao instante.`)
};

const en_cap_step2_body = /** @type {(inputs: Cap_Step2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When an owner needs a skipper in your area and dates, the proposal arrives instantly.`)
};

/**
* | output |
* | --- |
* | "When an owner needs a skipper in your area and dates, the proposal arrives instantly." |
*
* @param {Cap_Step2_BodyInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_step2_body = /** @type {((inputs?: Cap_Step2_BodyInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Step2_BodyInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_step2_body(inputs)
	if (locale === "en") return en_cap_step2_body(inputs)
	return es_cap_step2_body(inputs)
});